import { render, staticRenderFns } from "./InputGroupForm.vue?vue&type=template&id=59643736&"
import script from "./InputGroupForm.vue?vue&type=script&lang=js&"
export * from "./InputGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports